import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { expoDetails } from "@/mocks/homeData";

export default function ExpoSection() {
  return (
    <section id="expo" className="bg-tie-navy py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Content */}
          <div>
            <ScrollReveal>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/20 mb-4 md:mb-6">
                <span className="text-xs font-semibold text-tie-teal-light uppercase tracking-wider">
                  / Expo Wing
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-5xl font-bold text-white leading-tight">
                Textile Innovation Expo 2026
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <div className="mt-5 md:mt-6 flex flex-wrap items-center gap-3 md:gap-4">
                <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 text-white">
                  <i className="ri-calendar-line text-tie-teal-light" />
                  <span className="text-sm font-medium">
                    {expoDetails.date}
                  </span>
                </div>
                <div className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-white/10 text-white">
                  <i className="ri-map-pin-line text-tie-teal-light" />
                  <span className="text-sm font-medium">
                    {expoDetails.location}
                  </span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <p className="mt-5 md:mt-6 text-base md:text-lg text-white/70 leading-relaxed">
                {expoDetails.description}
              </p>
            </ScrollReveal>

            {/* Concurrent Expos */}
            <ScrollReveal delay={300}>
              <div className="mt-8 md:mt-10">
                <p className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 md:mb-4">
                  Concurrent Expos
                </p>
                <div className="space-y-2.5 md:space-y-3">
                  {expoDetails.concurrentExpos.map((expo) => (
                    <div
                      key={expo.name}
                      className="flex items-start gap-3 p-3 md:p-4 rounded-lg bg-white/5 border border-white/10 hover:border-tie-teal/30 transition-all"
                    >
                      <div className="w-8 h-8 rounded-lg bg-tie-teal/20 flex items-center justify-center shrink-0 mt-0.5">
                        <i className="ri-apps-line text-tie-teal-light text-sm" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-white">
                          {expo.name}
                        </p>
                        <p className="text-xs text-white/50 mt-0.5">
                          {expo.focus}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Right: Visual */}
          <ScrollReveal delay={200}>
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20international%20expo%20convention%20center%20hall%20with%20textile%20technology%20booths%20and%20displays%2C%20bustling%20professional%20exhibition%20floor%2C%20warm%20ambient%20lighting%20with%20teal%20and%20navy%20accent%20colors%2C%20premium%20corporate%20trade%20show%20atmosphere%2C%20Bangladesh%20convention%20center%20aesthetic&width=800&height=700&seq=6&orientation=squarish"
                alt="Textile Innovation Expo"
                className="w-full h-[300px] md:h-[450px] lg:h-[550px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-tie-navy/60 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="p-4 md:p-5 rounded-xl bg-white/10 backdrop-blur-md border border-white/20">
                  <p className="text-xs text-white/60 uppercase tracking-wider mb-1">
                    Marketplace for Innovation
                  </p>
                  <p className="text-base md:text-lg font-semibold text-white">
                    Matchmaking &middot; Technology Adoption &middot;
                    Collaboration
                  </p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}